import React from 'react';
import { connect } from 'react-redux';
import * as DocumentStorageActions from '../actions/documentStorage';
import ConfiguratorMenuPageElement from './ConfiguratorMenuPageElement.react'
import { injectIntl } from 'react-intl';
import ModalFormPageAdd from './forms/ModalFormPageAdd.react';
import update from 'react/lib/update';
import UUID from 'node-uuid';
import { FormattedMessage } from 'react-intl';
import { push } from 'react-router-redux';

class ConfiguratorMenuPage extends React.Component {

    constructor(props, context) {

        super(props, context);
        const { ConfiguratorManager } = props;

        let statePages = [];
        ConfiguratorManager.getPages().map(page => {

            let title = page.title;
            let previewThumb = page.previewThumb ? page.previewThumb : null;
            let selectedVariant = ConfiguratorManager.getPageVariant(page);
            if (selectedVariant) {
                title = selectedVariant.title;
                if (selectedVariant.previewThumb) {
                    previewThumb = selectedVariant.previewThumb
                }
            }

            statePages.push({
                id: page.id,
                title: title,
                deletable: page.deletable,
                ref: page.ref ? page.ref : null,
                previewThumb: previewThumb,
                variantId: selectedVariant ? selectedVariant.id : null,
                variants: ConfiguratorManager.getPageVariantLabels(page),
            });
        });

        this.state = {
            modalFormOpen: false,
            pages: statePages
        };

        // React components using ES6 classes no longer autobind this to non React methods. In your constructor, add:
        this.removePage = this.removePage.bind(this);
        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.addPage = this.addPage.bind(this);
        this.movePage = this.movePage.bind(this);
        this.updateStorageData = this.updateStorageData.bind(this);
        this.changePageVariant = this.changePageVariant.bind(this);
        this.redirectToPage = this.redirectToPage.bind(this);
    };

    static get defaultProps() {
        return {
            ConfiguratorManager: {}
        }
    }

    openModal() {
        this.setState({ modalFormOpen: true });
    }

    closeModal() {
        this.setState({ modalFormOpen: false });
    }

    addPage(pageById, newIndex) {

        if (newIndex.toString() === '-1') { // -1 === first position
            newIndex = 0;
        }

        let { ConfiguratorManager } = this.props;

        const sourcePage = ConfiguratorManager.getPageById(pageById);
        let newPage = null;
        if (sourcePage) {

            let title = sourcePage.title;
            let previewThumb = sourcePage.previewThumb ? sourcePage.previewThumb : null;
            let selectedVariant = ConfiguratorManager.getPageVariant(sourcePage);
            if (selectedVariant) {
                title = selectedVariant.title;
                if (selectedVariant.previewThumb) {
                    previewThumb = selectedVariant.previewThumb
                }
            }

            newPage = {
                id: UUID.v4(),
                title: title,
                deletable: true,
                ref: pageById,
                previewThumb: previewThumb,
                variantId: selectedVariant ? selectedVariant.id : null,
                variants: ConfiguratorManager.getPageVariantLabels(sourcePage),
            };
        }

        const newPages = update(this.state.pages, {
                $splice: [
                    [ newIndex, 0, newPage ]
                ]
            }
        );

        let newState = {...this.state};
        newState.pages = newPages;

        this.setState(newState, function() {
            this.updateStorageData();
            this.closeModal();
            this.redirectToPage(newPage.id);
        });
    }

    removePage(index) {
        const confirmMessage = this.props.intl.formatMessage({id: 'CONFIRM_DELETE_PAGE'});
        if(confirm(confirmMessage)) {
            this.setState(update(this.state, {
                    pages: {
                        $splice: [
                            [index, 1]
                        ]
                    }
                }),
                function() {
                    this.updateStorageData();
                    this.redirectToPage('0');
                }
            );
        }
    }

    movePage(dragIndex, hoverIndex) {

        const { pages } = this.state;
        const dragPageElement = pages[dragIndex];

        this.setState(update(this.state, { // @see https://facebook.github.io/react/docs/update.html
            pages: {
                $splice: [
                    [dragIndex, 1],
                    [hoverIndex, 0, dragPageElement]
                ]
            }
        }), function() {
            // this.updateStorageData();
        });
    }

    updateStorageData() {
        let { ConfiguratorManager, dispatch } = this.props;
        const updatedStorage = ConfiguratorManager.updatePagesInStorage(this.state.pages);
        dispatch(DocumentStorageActions.updateDocumentStorage(ConfiguratorManager.getStorageId(), null, null, updatedStorage));
    }

    changePageVariant(pageId, variantId) {

        // console.log('A11 - exec changePageVariant');

        let { ConfiguratorManager } = this.props;
        let pages = this.state.pages;
        let variant;

        pages.map((entry, index) => {
            if (entry.id.toString() === pageId.toString()) {

                variant = ConfiguratorManager.getPageVariantById(pageId, variantId);

                // change variantId, title & previewThumb
                pages[index].variantId = variantId.toString();
                if (variant.title) {
                    pages[index].title = variant.title;
                }
                if (variant.previewThumb) {
                    pages[index].previewThumb = variant.previewThumb;
                }
            }
        });

        this.setState({
            pages: pages
        }, function() {
            this.updateStorageData();
        });
    }

    redirectToPage(pageId) {
        const { ConfiguratorManager, dispatch } = this.props;
        const documentId = ConfiguratorManager.getDocumentId();
        const storageId = ConfiguratorManager.getStorageId();
        let url = '/configurator/';
            url += documentId + '/';
            url += storageId + '/';
            url += pageId + '/';

        dispatch(push(url));
    }

    render() {

        const { ConfiguratorManager, app, validatePage } = this.props;
        const appConfig = app.config;

        let addPageButton = null;
        if (ConfiguratorManager.isPageAddable()) {
            addPageButton = <button type="button" className="btn btn-info btn-block" onClick={ () => this.openModal() }>
                <i className="material-icons">note_add</i><FormattedMessage id="LABEL_ADD_PAGE" />
            </button>;
        }

        return (
            <aside>
                <div className="tab-content">
                    <div className="tab-pane active">
                        <div className="configuratorMenuPagePreview">
                            {
                                this.state.pages.map((pageEntry, index) => {
                                    return <ConfiguratorMenuPageElement
                                        pageEntry={pageEntry}
                                        ConfiguratorManager={ConfiguratorManager}
                                        movePage={this.movePage}
                                        removePage={this.removePage}
                                        addPage={this.addPage}
                                        changePageVariant={this.changePageVariant}
                                        validatePage={validatePage}
                                        updateStorageData={this.updateStorageData}
                                        redirectToPage={this.redirectToPage}
                                        key={index}
                                        index={index}
                                        appConfig={appConfig} />
                                })
                            }
                        </div>
                        { addPageButton }
                    </div>
                </div>

                <ModalFormPageAdd closeModal={ this.closeModal }  isOpenModal={ this.state.modalFormOpen } pages={ this.state.pages } addPage={ this.addPage } />

            </aside>
        );
    }
}

export default connect(state => ({ configurator: state.configurator, app: state.app, documentStorage: state.documentStorage}))(injectIntl(ConfiguratorMenuPage));


// WEBPACK FOOTER //
// ./src/js/components/ConfiguratorMenuPage.react.jsx